(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/my-information-panel.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/my-information-panel.js');
'use strict';

const {
  useEffect,
  useState
} = React;
const {
  getCustomerBankAccounts
} = svs.myProfile.react.store.pd.actions;
const {
  InfoPair,
  BankAccountCard
} = svs.myProfile.react.pages.myInformation.myInformation.components;
const {
  MobileCard
} = svs.myProfile.react.pages.myInformation.myInformation.mobile;
const {
  EmailCard
} = svs.myProfile.react.pages.myInformation.myInformation.email;
const {
  BingoCard
} = svs.myProfile.react.pages.myInformation.myInformation.bingo;
const {
  FULFILLED,
  REJECTED
} = svs.myProfile.constants.thunkStatus;
const {
  showTechnicalError
} = svs.myProfile.react.shared.dialogs;
const {
  Skeleton
} = svs.myProfile.react.shared.components;
const {
  toTitleCase
} = svs.myProfile.react.pages.myInformation.myInformationHelpers;
const isPnp = svs.core.config.data.svsconfig.site === 'momang';

const MyInformationPanel = _ref => {
  let {
    isAddAlias,
    isChangeEmail,
    isChangeMobile
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [aliasBingo, setAliasBingo] = useState('');
  const [aliasPoker, setAliasPoker] = useState('');
  const playerCustomizedSettings = ReactRedux.useSelector(state => state.playerCustomizedSettings.playerCustomizedSettings);
  const playerCustomizedSettingsStatus = ReactRedux.useSelector(state => state.playerCustomizedSettings.playerCustomizedSettingsStatus.status);
  const isPreferenceDataLoaded = ReactRedux.useSelector(state => state.playerCustomizedSettings.isPreferenceDataLoaded);
  useEffect(() => {
    dispatch(getCustomerBankAccounts());
  }, [dispatch]);
  useEffect(() => {
    if (playerCustomizedSettingsStatus === FULFILLED || playerCustomizedSettingsStatus === REJECTED) {
      if (!playerCustomizedSettings.customerId) {
        showTechnicalError();
      }
    }
  }, [playerCustomizedSettings, playerCustomizedSettingsStatus]);
  useEffect(() => {
    if (playerCustomizedSettingsStatus === FULFILLED) {
      if (playerCustomizedSettings !== null && playerCustomizedSettings !== void 0 && playerCustomizedSettings.firstName) {
        setName(toTitleCase("".concat(playerCustomizedSettings === null || playerCustomizedSettings === void 0 ? void 0 : playerCustomizedSettings.firstName, " ").concat(playerCustomizedSettings === null || playerCustomizedSettings === void 0 ? void 0 : playerCustomizedSettings.lastName).toLowerCase()));
      } else {
        setName(React.createElement("i", null, "Dold"));
      }
      if (playerCustomizedSettings !== null && playerCustomizedSettings !== void 0 && playerCustomizedSettings.street) {
        setAddress(toTitleCase("".concat(playerCustomizedSettings === null || playerCustomizedSettings === void 0 ? void 0 : playerCustomizedSettings.street, ", ").concat(playerCustomizedSettings === null || playerCustomizedSettings === void 0 ? void 0 : playerCustomizedSettings.zip, " ").concat(playerCustomizedSettings === null || playerCustomizedSettings === void 0 ? void 0 : playerCustomizedSettings.city).toLowerCase()));
      }
      if (playerCustomizedSettings !== null && playerCustomizedSettings !== void 0 && playerCustomizedSettings.alias) {
        setAliasBingo(toTitleCase("".concat(playerCustomizedSettings === null || playerCustomizedSettings === void 0 ? void 0 : playerCustomizedSettings.alias).toLowerCase()));
      }
      if (playerCustomizedSettings !== null && playerCustomizedSettings !== void 0 && playerCustomizedSettings.nicknamePoker) {
        setAliasPoker(toTitleCase("".concat(playerCustomizedSettings === null || playerCustomizedSettings === void 0 ? void 0 : playerCustomizedSettings.nicknamePoker).toLowerCase()));
      }
    }
  }, [playerCustomizedSettings, playerCustomizedSettingsStatus]);
  return React.createElement("div", {
    className: "f-center margin-bottom-4"
  }, !isPreferenceDataLoaded && React.createElement(React.Fragment, null, React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 1,
    boxWidthProcent: 70,
    topMargin: 0
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 1,
    boxWidthProcent: 70,
    topMargin: 1
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 1,
    boxWidthProcent: 70,
    topMargin: 1
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 6,
    boxWidthProcent: 100,
    topMargin: 4
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 6,
    boxWidthProcent: 100,
    topMargin: 1
  }), React.createElement(Skeleton, {
    bottomMargin: 4,
    boxHeight: 6,
    boxWidthProcent: 100,
    topMargin: 1
  })), isPreferenceDataLoaded && React.createElement(React.Fragment, null, React.createElement("h2", {
    className: "align-center h2 margin-bottom-1"
  }, React.createElement("span", {
    className: "f-medium"
  }, name)), aliasBingo && React.createElement(InfoPair, {
    info: aliasBingo,
    title: "Alias f\xF6r Bingo"
  }), aliasPoker && React.createElement(InfoPair, {
    info: aliasPoker,
    title: "Alias f\xF6r Poker"
  }), React.createElement(InfoPair, {
    info: address,
    title: "Adress"
  }), React.createElement(EmailCard, {
    isFocused: isChangeEmail
  }), React.createElement(MobileCard, {
    isFocused: isChangeMobile
  }), React.createElement(BankAccountCard, null), !aliasBingo && !isPnp && React.createElement(BingoCard, {
    aliasBingo: aliasBingo,
    isFocused: isAddAlias
  })));
};
svs.myProfile.react.pages.myInformation.myInformation.MyInformationPanel = MyInformationPanel;

 })(window);